import React from 'react';
import MonthlyForecastChart from './MonthlyForecastChart';
import 'katex/dist/katex.min.css';
import TeX from '@matejmazur/react-katex';

const HoltWintersForecast = (props) => {
  return (
    <div class="container">
      <h3>Holt-Winters Exponential Smoothing Forecast</h3>
      <MonthlyForecastChart />
      <hr />
      <p>
        We used the&nbsp;
        <a href="https://www.rdocumentation.org/packages/stats/versions/3.6.2/topics/HoltWinters">
          <i>Holt-Winters model</i>
        </a>
        &nbsp;(triple exponential smoothing) in R to predicted new cases of anthrax from 2020 to 2024 in Gannan Tibetan Autonomous Prefecture.
      </p>
      <p>
        The additive Holt-Winters prediction function (for time series with period length p) is
        <TeX block>{String.raw`
          \hat{Y}_{t+h} = a_t + h b_t + s_{t - p + 1 + (h - 1) \text{ mod } p},
        `}</TeX>
        where
        <TeX block>{String.raw`
          \begin{aligned}
	          a_t &= \alpha(Y_t - s_{t-p} + (1 - \alpha)(a_{t-1} + b_{t-1}),\\
            b_t &= \beta(a_t - a_{t-1}) + (1 - \beta)b_{t-1},\\
            s_t &= \gamma(Y_t - a_t) + (1 - \gamma)s_{t-p}.
          \end{aligned}
        `}</TeX>
      </p>
    </div>
  );
}

export default HoltWintersForecast;